import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { CentroService } from './centro.service';
import { Centro } from './centro';
import { Unidade } from './../unidades/unidade';

declare var Materialize:any;

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  providers: [CentroService]
})
export class FormCentrosComponent implements OnInit {
  public busy: Promise<any>;
  titulo: string = "Centros";
  centro: Centro;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private centroService: CentroService
  ) {
    this.centro = new Centro();
  }

  get(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];

      if(id !== undefined ){
        this.busy = this.centroService.getCentro(id)
          .then(centro => this.centro = centro );
      }
    });
  }



  salvar(): void {
    this.busy = this.centroService.saveCentro(this.centro)
            .then(() => this.goBack());
  }

  goBack(): void {
     this.router.navigate(['/centros']);
  }

  ngOnInit() {
    this.get();
  }



}



// WEBPACK FOOTER //
// ./src/app/centros/form.component.ts